import React from "react";
import classes from "./PageLayout.module.css";

const PageLayout = ({ children }) => {
  return <div className={`${classes.page} page__container`}>{children}</div>;
};

export default PageLayout;
